export default {
  props: {
    filterFunc: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      localSearchValue: null
    }
  },
  computed: {
    loading () {
      return this.$store.getters['staff/isLoading']
    },
    results () {
      const searchVal = (this.localSearchValue || '').toLowerCase()
      const results = this.$store.getters['staff/getStaff'].filter(item =>
        (item.name || '').toLowerCase().includes(searchVal) ||
        (item.email || '').toLowerCase().includes(searchVal)
      )
      return this.filterFunc ? results.filter(this.filterFunc) : results
    }
  },
  methods: {
    async doSearch (value, successCallback = () => {}, _errorCallback = () => {}) {
      await this.$store.dispatch('staff/getStaff')

      this.localSearchValue = value
      successCallback()
    }
  }
}
